<template>
  <div class="renewals-layout">
    <div class="page-header">
      <div>
        <h1 class="page-title">Souscriptions</h1>
        <p class="page-subtitle">Plans d’utilisation, paiements et fonctionnalités</p>
      </div>
    </div>

    <v-card class="renewals-tabs-card mb-4 mx-6" flat>
      <v-tabs background-color="transparent" show-arrows slider-color="secondary">
        <v-tab
          v-for="tab in tabs"
          :key="tab.path"
          :to="tab.path"
          exact
        >
          <v-icon left small class="mr-1">{{ tab.icon }}</v-icon>
          {{ tab.label }}
        </v-tab>
      </v-tabs>
    </v-card>

    <router-view />

    <FlashMessage :position="'right bottom'" />
  </div>
</template>

<script>
export default {
  name: 'RenewalsLayout',
  data() {
    return {
      tabs: [
        { path: '/renewals/plans-utilisation', label: "Plans d'utilisation", icon: 'mdi-view-grid-outline' },
        { path: '/renewals/paiements-plan', label: 'Paiements plans', icon: 'mdi-credit-card-multiple' },
        { path: '/renewals/plans-fonctionnalites', label: 'Plans fonctionnalités', icon: 'mdi-puzzle-outline' },
        { path: '/renewals/paiements-fonctionnalites', label: 'Paiements fonctionnalités', icon: 'mdi-feature-search' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.renewals-layout {
  min-height: 100%;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;

  .page-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }

  .page-subtitle {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    margin: 4px 0 0;
  }
}

.theme--dark .page-subtitle {
  color: rgba(255, 255, 255, 0.6);
}

.renewals-tabs-card {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.theme--dark .renewals-tabs-card {
  border-color: rgba(255, 255, 255, 0.12) !important;
}

@media (max-width: 599px) {
  .page-header {
    padding: 16px;
  }

  .renewals-tabs-card {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }
}
</style>
